// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.6/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.team-management_header__UfW\\+a {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.team-management_header-wrapper__IE9Ka {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.team-management_title__aI3El {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.team-management_title-wrapper__Oigcs {
  display: flex;
  align-items: center;
  gap: 4px;
}

.team-management_actions__tuM8K {
  display: flex;
  gap: 12px;
}

.team-management_wrapper__MQ2bp {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.team-management_name-wrapper__GGIsL {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 12px;
}

.team-management_name-infos__Xf\\+vR {
  display: grid;
  min-width: 50px;
  gap: 4px;

  & p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.team-management_icon__o8ZO4 {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

tr:nth-child(4n + 1) .team-management_icon__o8ZO4 {
  background-color: #f0c7c7;
}

tr:nth-child(4n + 2) .team-management_icon__o8ZO4 {
  background-color: #cfc7f0;
}

tr:nth-child(4n + 3) .team-management_icon__o8ZO4 {
  background-color: #c7f0e0;
}

tr:nth-child(4n + 4) .team-management_icon__o8ZO4 {
  background-color: #f7ffc4;
}

.team-management_actions-column__ozr-y {
  display: flex;
  justify-content: end;
}

.team-management_empty__d-e\\+A {
  display: flex;
  justify-content: center;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/routes/teams/team-management.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;;EAER;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":[".header {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.header-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.title {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.title-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.actions {\n  display: flex;\n  gap: 12px;\n}\n\n.wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.name-wrapper {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  align-items: center;\n  gap: 12px;\n}\n\n.name-infos {\n  display: grid;\n  min-width: 50px;\n  gap: 4px;\n\n  & p {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n.icon {\n  width: 25px;\n  height: 25px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\ntr:nth-child(4n + 1) .icon {\n  background-color: #f0c7c7;\n}\n\ntr:nth-child(4n + 2) .icon {\n  background-color: #cfc7f0;\n}\n\ntr:nth-child(4n + 3) .icon {\n  background-color: #c7f0e0;\n}\n\ntr:nth-child(4n + 4) .icon {\n  background-color: #f7ffc4;\n}\n\n.actions-column {\n  display: flex;\n  justify-content: end;\n}\n\n.empty {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `team-management_header__UfW+a`,
	"header-wrapper": `team-management_header-wrapper__IE9Ka`,
	"title": `team-management_title__aI3El`,
	"title-wrapper": `team-management_title-wrapper__Oigcs`,
	"actions": `team-management_actions__tuM8K`,
	"wrapper": `team-management_wrapper__MQ2bp`,
	"name-wrapper": `team-management_name-wrapper__GGIsL`,
	"name-infos": `team-management_name-infos__Xf+vR`,
	"icon": `team-management_icon__o8ZO4`,
	"actions-column": `team-management_actions-column__ozr-y`,
	"empty": `team-management_empty__d-e+A`
};
export default ___CSS_LOADER_EXPORT___;
